import { render, staticRenderFns } from "./ResponsableFirmaForm.vue?vue&type=template&id=4b121299"
import script from "./ResponsableFirmaForm.vue?vue&type=script&lang=js"
export * from "./ResponsableFirmaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports